

































































import iScaler from "./i-scaler.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

interface IScrollViewDatas {
  mode: string;
  data: {
    span: number;
    ratio: string;
    scaler: {
      type: string;
      data: any;
    };
  }[];
}

@Component({
  components: {
    iScaler
  }
})
export default class iScrollView extends Vue {
  @Prop({
    required: true,
    default: null
  })
  datas!: IScrollViewDatas | null;

  private scrollview!: Element;

  private scrolling = false;

  mounted() {
    this.scrollview = this.$refs.scrollview as Element;
  }

  private start: undefined | number = undefined;
  private scrollOffset: number = 0;
  private scrollStart: number = 0;

  private scrollTo(timestamp: number) {
    if (this.start === undefined) this.start = timestamp;
    const elapsed = timestamp - this.start;
    this.scrollview.scrollTo(
      this.scrollStart + (elapsed / 300) * this.scrollOffset,
      0
    );
    if (elapsed < 300) {
      window.requestAnimationFrame(this.scrollTo);
    } else {
      setTimeout(() => {
        this.scrolling = false;
      }, 500);
    }
  }

  private scrollNext() {
    if (!this.scrolling) {
      this.scrolling = true;
      this.start = undefined;
      this.scrollStart = this.scrollview.scrollLeft;
      this.scrollOffset = this.scrollview.clientWidth;
      window.requestAnimationFrame(this.scrollTo);
    }
  }

  private scrollPrev() {
    if (!this.scrolling) {
      this.scrolling = true;
      this.start = undefined;
      this.scrollStart = this.scrollview.scrollLeft;
      this.scrollOffset = -this.scrollview.clientWidth;
      window.requestAnimationFrame(this.scrollTo);
    }
  }

  private onWheel(event: WheelEvent) {
    if (
      !this.scrolling &&
      this.scrollview.scrollWidth > this.scrollview.scrollHeight
    ) {
      if (event.deltaY > 0 || event.deltaX > 0) this.scrollNext();
      else this.scrollPrev();
    }
  }
}
